// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Medal24FilledProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Medal24Filled: FC<Medal24FilledProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="24"
            height="24"
        >
            <path d="M12 13a2.893 2.893 0 0 1-2.125-.875A2.893 2.893 0 0 1 9 10c0-.833.292-1.542.875-2.125A2.893 2.893 0 0 1 12 7c.833 0 1.542.292 2.125.875S15 9.167 15 10s-.292 1.542-.875 2.125A2.893 2.893 0 0 1 12 13ZM6 23v-7.725a7.707 7.707 0 0 1-1.475-2.4A7.862 7.862 0 0 1 4 10c0-2.233.775-4.125 2.325-5.675C7.875 2.775 9.767 2 12 2c2.233 0 4.125.775 5.675 2.325C19.225 5.875 20 7.767 20 10a7.862 7.862 0 0 1-.525 2.875c-.35.9-.842 1.7-1.475 2.4V23l-6-2-6 2Zm6-7c1.667 0 3.083-.583 4.25-1.75C17.417 13.083 18 11.667 18 10c0-1.667-.583-3.083-1.75-4.25C15.083 4.583 13.667 4 12 4c-1.667 0-3.083.583-4.25 1.75C6.583 6.917 6 8.333 6 10c0 1.667.583 3.083 1.75 4.25C8.917 15.417 10.333 16 12 16Z" />
        </svg>
    );
};

export default Medal24Filled;
